const socials = [
  { label: 'Instagram', href: 'https://www.instagram.com/coloured_ink/' },
  { label: 'GitHub', href: 'https://github.com/Anan23Ked' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/ananyakedlaya/' },
  { label: 'Email', href: 'mailto:kedlayaananya@gmail.com' },
];

export default function Footer() {
  return (
    <footer className="border-t border-cream-400/60 px-10 md:px-16 lg:px-20 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <span className="label">© 2025 Ananya Kedlaya</span>
      <div className="flex items-center gap-8">
        {socials.map(({ label, href }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="label hover:text-ink transition-colors duration-200"
          >
            {label}
          </a>
        ))}
      </div>
    </footer>
  );
}
